// Cookie-consent state for analytics. We treat analytics cookies as opt-in:
// Google Analytics is not loaded until the user explicitly consents, consent is
// stored locally, and it can be withdrawn at any time. Strictly necessary
// session cookies are unaffected by this — they are always required to sign in.

export type ConsentValue = 'granted' | 'denied';

const STORAGE_KEY = 'gooey_cookie_consent';

// Dispatched on window to (re)open the consent banner — e.g. from the
// "Cookie settings" control in the Privacy Policy. Listened for by <CookieConsent>.
export const COOKIE_SETTINGS_EVENT = 'gooey:open-cookie-settings';

export function getStoredConsent(): ConsentValue | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'granted' || v === 'denied' ? v : null;
  } catch {
    // localStorage can throw in private-mode / sandboxed contexts — treat as "no decision".
    return null;
  }
}

export function storeConsent(value: ConsentValue): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Best effort — if we can't persist, the banner simply reappears next load.
  }
}

export function openCookieSettings(): void {
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
}
